var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number",on:{"click":_vm.click}},[_c('div',{staticClass:"number-text"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"number-center"},[_vm._v(_vm._s(_vm.number))])])}
var staticRenderFns = []

export { render, staticRenderFns }